import { IAvailableColumnModel, IFilterColumnModel } from 'interfaces';

const REAL_ESTATE_FILTER: IAvailableColumnModel = {
  columnName: 'realEstateGuid',
  caption: 'ИД Объекта недвижимости',
  filterCaption: 'Объект недвижимости',
  type: 'String',
  filterCriteriaList: ['IN'],
  dictionaryMap: {
    dictionaryUrl: '/dictionary/realEstatesLimit20',
    keyColumnName: 'guid',
    valueColumnName: 'name',
    searchColumn: 'name',
  },
};

const IS_PUBLIC_FILTER: IAvailableColumnModel = {
  columnName: 'isPublic',
  caption: 'Публичная',
  filterCaption: 'Публичная',
  type: 'Boolean',
  filterCriteriaList: ['EQ'],
  dictionaryMap: null,
};

export const handleClickHasPublicApplicationButton = ({
  realEstateGuid,
  realEstateName,
}: {
  realEstateGuid?: string;
  realEstateName?: string;
}) => {
  const STORAGE_KEY = 'applications';
  const filterConfig: {
    filterColumns: IFilterColumnModel[];
    visibleFilters: IAvailableColumnModel[];
  } = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');

  const columnNames = (filterConfig?.filterColumns || []).map(({ columnName }) => columnName);
  const filterNames = (filterConfig?.visibleFilters || []).map(({ columnName }) => columnName),
    REAL_ESTATE_COLUMN = {
      columnName: 'realEstateGuid',
      criteria: 'IN',
      filterValues: [{ key: realEstateGuid, value: realEstateName }],
    },
    IS_PUBLIC_COLUMN = { columnName: 'isPublic', criteria: 'EQ', filterValues: [true] };

  const filterColumns = filterConfig?.filterColumns || [];
  if (!columnNames.includes(REAL_ESTATE_COLUMN.columnName) && realEstateGuid) filterColumns.push(REAL_ESTATE_COLUMN);
  if (!columnNames.includes(IS_PUBLIC_COLUMN.columnName)) filterColumns.push(IS_PUBLIC_COLUMN);

  const visibleFilters = filterConfig?.visibleFilters || [];
  if (!filterNames.includes(REAL_ESTATE_COLUMN.columnName) && realEstateGuid) visibleFilters.push(REAL_ESTATE_FILTER);
  if (!filterNames.includes(IS_PUBLIC_COLUMN.columnName)) visibleFilters.push(IS_PUBLIC_FILTER);

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...filterConfig,
      filterColumns: filterColumns
        .filter(({ columnName }) => [REAL_ESTATE_COLUMN.columnName, IS_PUBLIC_COLUMN.columnName].includes(columnName))
        .map((filterColumn) => {
          if (filterColumn.columnName === REAL_ESTATE_COLUMN.columnName && realEstateGuid)
            filterColumn = REAL_ESTATE_COLUMN;
          if (filterColumn.columnName === IS_PUBLIC_COLUMN.columnName) filterColumn = IS_PUBLIC_COLUMN;

          return filterColumn;
        }),
      visibleFilters: visibleFilters.map((visibleFilter) => {
        if (visibleFilter.columnName === REAL_ESTATE_COLUMN.columnName && realEstateGuid)
          visibleFilter = REAL_ESTATE_FILTER;
        if (visibleFilter.columnName === IS_PUBLIC_COLUMN.columnName) visibleFilter = IS_PUBLIC_FILTER;

        return visibleFilter;
      }),
    }),
  );
};
